/* global wx */
/**
 * 人脸认证成功后跳回小程序的统一入口。
 * pageFlag 契约（与后端约定）：值直接就是目标小程序页面，前端不维护任何写死映射——
 *   - 页面名（如 'newsuccess'）→ 按项目目录约定拼成 /pages/名字/名字
 *   - 完整路径（如 '/pages/newsuccess/newsuccess'，开头斜杠可省）→ 原样使用
 *   - 缺省/空 → 老链路 /pages/success/success
 * pageFlag 来源：认证回跳 URL 参数；loginMiniSign / verifyToken 响应的 data.pageFlag（计划配置了才返回）。
 * 目标页面在小程序里不存在时由 fail 兜底回老链路。
 * 详见小程序仓库 docs/superpowers/specs/2026-11-04-newsuccess-pageflag-design.md
 */
const LEGACY_PAGE = '/pages/success/success'
const LEGACY_OVER_PAGE = '/pages/overRight/overRight'
// 已签到(2003)落地页：success 型页面 → 对应 OverRight 型回显页；未登记配对的走老 overRight
// （success/overRight 是老链路固有命名，无法从页面名推导，只能登记；新增带回显页的链路时加一行）
const OVER_PAGE_MAP = {
  '/pages/newsuccess/newsuccess': '/pages/newOverRight/newOverRight'
}

// 纯函数：pageFlag → 页面路径（不含查询串），便于测试
function resolvePagePath(pageFlag) {
  if (!pageFlag) return LEGACY_PAGE
  if (pageFlag.indexOf('/pages/') === 0) return pageFlag
  if (pageFlag.indexOf('pages/') === 0) return '/' + pageFlag
  return '/pages/' + pageFlag + '/' + pageFlag
}

// 纯函数：仅决定目标完整地址，便于测试
function successPagePath(certifyId, pageFlag) {
  const page = resolvePagePath(pageFlag)
  return page + (page.indexOf('?') >= 0 ? '&' : '?') + 'certifyId=' + certifyId
}

// 纯函数：pageFlag → 已签到(2003)应落地的回显页路径，便于测试
function overPagePath(pageFlag) {
  return OVER_PAGE_MAP[resolvePagePath(pageFlag)] || LEGACY_OVER_PAGE
}

// 副作用：销毁 web-view 跳转小程序原生页（销毁时机同时触发 postMessage 送达，勿改 navigateTo）
function redirectToMiniPage(url, fallbackUrl) {
  if (typeof wx === 'undefined' || !wx.miniProgram) {
    // 浏览器调试环境：只打日志，不报错
    console.log('[authRoute] 非小程序环境，模拟跳转:', url)
    return
  }
  console.log('[authRoute] 跳转:', url)
  wx.miniProgram.redirectTo({
    url: url,
    success: () => console.log('跳转成功:', url),
    fail: (err) => {
      console.error('跳转失败:', err.errMsg)
      // 兜底：小程序里没有该页面（如老版本）时退回兜底页，避免考生卡死（只兜一次，不再挂 fail 防循环）
      if (url !== fallbackUrl) {
        wx.miniProgram.redirectTo({ url: fallbackUrl })
      }
    }
  })
}

// 认证成功页（含 pageFlag 动态解析），兜底老 success
function redirectSuccessPage(certifyId, pageFlag) {
  redirectToMiniPage(
    successPagePath(certifyId, pageFlag),
    LEGACY_PAGE + '?certifyId=' + certifyId
  )
}

// 已签到回显页（2003 分支），兜底老 overRight
function redirectOverPage(certifyId, pageFlag) {
  redirectToMiniPage(
    overPagePath(pageFlag) + '?certifyId=' + certifyId,
    LEGACY_OVER_PAGE + '?certifyId=' + certifyId
  )
}

module.exports = { successPagePath, redirectSuccessPage, overPagePath, redirectOverPage }
